import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ThfPageLogin } from './interfaces/thf-page-login.interface';
import { ThfPageLoginAuthenticationType } from './enums/thf-page-login-authentication-type.enum';

@Injectable()
export class ThfPageLoginService {

  constructor(private http: HttpClient) { }

  onLogin(url: string, type: ThfPageLoginAuthenticationType, loginForm: ThfPageLogin): Observable<Object> {

    if (type === ThfPageLoginAuthenticationType.Bearer) {
      loginForm.password = btoa(loginForm.password);
      return this.http.post(url, loginForm);
    } else {
      const user = `(${loginForm.login}:${loginForm.password})`;
      const headers = new HttpHeaders({
        'Authorization': `${type} ` + btoa(user)
      });
      delete loginForm.login;
      delete loginForm.password;
      return this.http.post(url, loginForm, { headers });
    }

  }

}
